import { Box } from "@mui/joy";

const FooterComponent = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px', borderTop: '1px solid', borderColor: 'divider' }}>
      <a href="https://discord.gg/G4ZnQQfubN" target="_blank" rel="noopener noreferrer" style={{ color: '#CDD7E1', marginLeft: '10px' }}>
        <i className="fab fa-discord fa-lg"></i>
      </a>
      <a href="https://twitter.com/VelbitApp" target="_blank" rel="noopener noreferrer" style={{ color: '#CDD7E1', marginLeft: '10px' }}>
        <i className="fab fa-twitter fa-lg"></i>
      </a>
      <a href="https://www.instagram.com/velbitapp/" target="_blank" rel="noopener noreferrer" style={{ color: '#CDD7E1', marginLeft: '10px' }}>
        <i className="fab fa-instagram fa-lg"></i>
      </a>
    </Box>
  );
};

export default FooterComponent;
